/* template */
<template><mpx-view @tap="goCities" class="btn-city-select"><span :class="({      compact: compact    })" class="city-name">{{ cityName }}</span><mpx-image src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAICAYAAAAvOAWIAAAAAXNSR0IArs4c6QAAAHhlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAACQAAAAAQAAAJAAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAAugAwAEAAAAAQAAAAgAAAAAFJOYdwAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAHNJREFUGBlj/P//fx4DA4MrEBMCu5mAKvgJqYLK84MUTwbi1wQ0gOQnMzEyMn4AMloJKG4FqQOZzABk3AVS3Tg0dEPlGcCKoRoOAek1aBrWABWCxMEArhjEA0osBFKnwDJAGsqHcrFQwKBkA2ILIOZAlwYA85AcVP9kXr0AAAAASUVORK5CYII=" class="icon-down"/></mpx-view></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m4c940890"}'>
.btn-city-select
  height 88rpx
  display flex
  flex-flow row nowrap
  justify-content flex-start
  align-items center
.city-name
  font-size 24rpx
  margin-right 9rpx
  color #fff
  &.compact
    text-align right
    width 5em
    text-overflow ellipsis
    white-space nowrap
    overflow hidden
.icon-down
  width 13rpx
  height 8rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import mpx, { createComponent } from '@mpxjs/core'
import { GlobalEnv, login } from '../../../../lib/webx'
import { TrackMap } from '../../../../lib/webx/common_methods/track_map'
import { getProdConfFromApollo } from '../../../../lib/webx/global_env/get_prod_config'

createComponent({
  name: 'BtnCitySelect',
  properties: {
    cityName: String,
    cityId: [ String, Number ],
    compact: {
      type: Boolean,
      value: false,
    },
  },
  methods: {
    goCities() {
      const ignoreToken = getProdConfFromApollo(null, {
        searchKey: 'index.select_city_ignore_login',
      })
      if (GlobalEnv.loginInfo.token || ignoreToken) {
        TrackMap.index.click(TrackMap.index.click.CKType.ChangeCity)
        mpx.navigateTo({ url: 'cities' })
      } else {
        login().then(() => {
          window.location.reload()
        })
      }
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "btn_city_select4c940890",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("builtInComponent.vue!=!../../../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("builtInComponent.vue!=!../../../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
